import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-ferme-bon-sortie',
  templateUrl: './ferme-bon-sortie.component.html',
  styleUrls: ['./ferme-bon-sortie.component.scss']
})
export class FermeBonSortieComponent implements OnInit {

    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        this.dataService.filterOrdersByStatus('Tous');
    }

}
